export default __webpack_public_path__ + "static/media/server.6c1c945c.png";